import {DokumentAnnoteringId, DokumentVersjonModell, HttpsUrl} from "../tjenester/ressurser/generertNg2HttpKlient";
import {uriEnkodet} from "felles/stoettefunk/uri";
import {mimetyper} from "./mimetyper";
import {erIkkeNil, erNil} from "./nilsjekk";
import {erIkkeNill} from "felles/stoettefunk/nillsjekk";

//** @deprecated bruk RessursAdresser.pdfjsDokumentViserUrl */
export function pdfjsDokumentViserUrl(serviceRotUrl: HttpsUrl, dokumentversjon: DokumentVersjonModell, forespurtAnnoteringId?: DokumentAnnoteringId): HttpsUrl {
    //vi bygger to versjoner av pdf.js - en for moderne nettlesere og en for eldre - sjekker her hvilken vi skal servere
    const legacy = brukPdfJsLegacy();
    let url = `${serviceRotUrl}/app/visdokument/pdf${legacy ? '-legacy' : ''}/versjon/${dokumentversjon.id}/${uriEnkodet(mimetyper.pdf.mimetype)}/${uriEnkodet(dokumentversjon.pdfFilnavn!)}`;
    if (erIkkeNil(forespurtAnnoteringId)) url = `${url}?forespurtAnnoteringId=${forespurtAnnoteringId}`;
    return url;
}

export function leggTilAnnoteringIdTilPdfjsUrl(pdfjsUrl: HttpsUrl, forespurtAnnoteringId: DokumentAnnoteringId | null) {
    if (erNil(forespurtAnnoteringId)) return pdfjsUrl;
    const prefix = pdfjsUrl.includes('?') ? '&' : '?';
    return `${pdfjsUrl}${prefix}forespurtAnnoteringId=${forespurtAnnoteringId}`;
}

/**
 * Vi bygger to versjoner av pdf.js - en for moderne nettlesere og en for eldre.
 * <pre>
 * Antar legacy dersom Promise.withResolvers ikke eksisterer, se dokumentasjon i
 * vårt pdfjs prosjekt ( https://github.com/systemfabrikken/lederplan-pdfjs ),
 * under aktiv annotering-branch i filen /sfannotering/README.md
 *
 * Merk at angular patcher bla Promise objektet via zone.js,
 * derfor __zone_symbol__Promise sjekken.
 *
 * Promise.withResolvers ble introdusert i Ecmascript 2023
 * og tatt i bruk i pdfjs i 4.2.67
 * </pre>
 */
export function brukPdfJsLegacy() {
    // @ts-ignore
    if (window['__zone_symbol__Promise'] && !window['__zone_symbol__Promise']['withResolvers']) return true;
    // @ts-ignore
    if (!Promise['withResolvers']) return true;
    return false;
}

/**
 * pdfjs oppgir at Safari >= 16.4 er støttet i legacy-bygg. String.isWellFormed ble introdusert i Safari 16.4,
 * Chrome og Edge 111 (Mars 2023), Firefox 119 (Oktober 2023).
 */
export function støtterPdfjs() {
    // @ts-ignore
    return erIkkeNill(String.prototype['isWellFormed']);
}
